import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
`

export const Title = styled.h1`
  align-self: flex-end;
`

export const Icon = styled.i`
  border-radius: 50%;
  background-color: #ffccb9;
  display: flex;
  align-items: center;
  padding: 0.2rem;
  cursor: pointer;
`
